import { StatusChipV2Color, tokens } from '@cast/design-system';
import { VulnerabilitySeverity } from '@cast/types';

import { CheckResourceState } from './types';

export const availableSeverityLevels: VulnerabilitySeverity[] = [
  VulnerabilitySeverity.critical,
  VulnerabilitySeverity.high,
  VulnerabilitySeverity.medium,
  VulnerabilitySeverity.low,
  VulnerabilitySeverity.none,
  VulnerabilitySeverity.notAvailable,
];

export const severitySortWeight: Record<VulnerabilitySeverity, number> = {
  [VulnerabilitySeverity.critical]: 5,
  [VulnerabilitySeverity.high]: 4,
  [VulnerabilitySeverity.medium]: 3,
  [VulnerabilitySeverity.low]: 2,
  [VulnerabilitySeverity.none]: 1,
  [VulnerabilitySeverity.notAvailable]: 0,
  [VulnerabilitySeverity.any]: 0,
};

/** Categorical severity colors; theme.data tokens adapt in dark mode. */
export const severityToColorMap: Partial<
  Record<
    VulnerabilitySeverity,
    { color: string; bgcolor: string; markerColor: string }
  >
> = {
  [VulnerabilitySeverity.critical]: {
    color: tokens.theme.data.red900,
    bgcolor: tokens.theme.data.red200,
    markerColor: tokens.theme.data.red800,
  },
  [VulnerabilitySeverity.high]: {
    color: tokens.theme.data.red500,
    bgcolor: tokens.theme.data.red50,
    markerColor: tokens.theme.data.red300,
  },
  [VulnerabilitySeverity.medium]: {
    color: tokens.theme.data.red400,
    bgcolor: tokens.theme.data.yellow200,
    markerColor: tokens.theme.data.yellow700,
  },
  [VulnerabilitySeverity.low]: {
    color: tokens.theme.data.yellow900,
    bgcolor: tokens.theme.data.yellow50,
    markerColor: tokens.theme.data.yellow200,
  },
  [VulnerabilitySeverity.none]: {
    color: tokens.theme.data.indigo500,
    bgcolor: tokens.theme.data.indigo50,
    markerColor: tokens.theme.data.indigo100,
  },
  [VulnerabilitySeverity.notAvailable]: {
    color: tokens.theme.data.grey600,
    bgcolor: tokens.theme.data.grey200,
    markerColor: tokens.theme.data.grey200,
  },
};

/** Semantic StatusChipV2 colors for severity score / status chips. */
export const severityToStatusChipColor: Record<
  VulnerabilitySeverity,
  StatusChipV2Color
> = {
  [VulnerabilitySeverity.critical]: 'error',
  [VulnerabilitySeverity.high]: 'error',
  [VulnerabilitySeverity.medium]: 'warning',
  [VulnerabilitySeverity.low]: 'warning',
  [VulnerabilitySeverity.none]: 'info',
  [VulnerabilitySeverity.notAvailable]: 'neutral',
  [VulnerabilitySeverity.any]: 'neutral',
};

export const severityToTextMap: Partial<Record<VulnerabilitySeverity, string>> =
  {
    [VulnerabilitySeverity.notAvailable]: 'N/A',
  };

export const severityToTooltipMap: Partial<
  Record<VulnerabilitySeverity, string>
> = {
  [VulnerabilitySeverity.none]:
    'Issue that does not impact security or operations but contains recommendation level information.',
  [VulnerabilitySeverity.notAvailable]: 'CVSS score not provided yet.',
};

export const checkResourceStateToText: Record<CheckResourceState, string> = {
  [CheckResourceState.NOT_AVAILABLE]: 'N/A',
  [CheckResourceState.AFFECTED]: 'Not compliant',
  [CheckResourceState.UNAFFECTED]: 'Compliant',
};
